export enum HaloMap
{
	Aquarius = "Aquarius",
	Bazaar = "Bazaar",
	Behemoth = "Behemoth",
	Deadlock = "Deadlock",
	Fragmentation = "Fragmentation",
	Highpower = "Highpower",
	LaunchSite = "Launch Site",
	LiveFire = "Live Fire",
	Recharge = "Recharge",
	Streets = "Streets"
}

export enum HaloMode
{
	Attrition = "Attrition",
	CTF = "CTF",
	FFASlayer = "FFA Slayer",
	Fiesta = "Fiesta",
	Oddball = "Oddball",
	Slayer = "Slayer",
	Stockpile = "Stockpile",
	Strongholds = "Strongholds",
	TacticalSlayer = "Tactical Slayer",
	TotalControl = "Total Control"
}

export enum HaloRanked
{
	Yes = "true",
	No = "false"
}

export enum HaloOutcome
{
	Win = "win",
	Loss = "loss",
	Draw = "draw",
	Left = "left"
}

export enum ServiceRecordFilter
{
	Social = "social",
	Ranked = "ranked",
	Variant = "variant",
	Playlist = "playlist",
	Maps = "maps",
	Modes = "modes",
	Outcomes = "outcomes",
	Local = "LAN",
	Customs = "customs"
}

export enum Leaderboard
{
	Accuracy = "accuracy",
	Assists = "assists",
	AssistsPerGame = "assists_per_game",
	Callouts = "callouts",
	CSR = "csr",
	Damage = "damage",
	Deaths = "deaths",
	DeathsPerGame = "deaths_per_game",
	KDA = "kda",
	KDR = "kdr",
	Kills = "kills",
	KillsPerGame = "kills_per_game",
	SpartanRank = "spartan_rank",
}